import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { deleteEmptyData } from 'src/app/config/app-utils';
import { SessionService } from '../../../services/session.service';

@Component({
  selector: 'app-resetear-clave',
  templateUrl: './resetear-clave.component.html'
})
export class ResetearClaveComponent implements OnInit {

  dataForm: FormGroup;

  constructor(private fb: FormBuilder, private toastr: ToastrService, private service: SessionService, private router: Router) {

  }

  ngOnInit() {
    window.scrollTo(0, 0);
    this.dataForm = this.fb.group({
      codigoUsuario: ['', [Validators.required]]
    })
  }

  solicitud() {
    let data = deleteEmptyData(this.dataForm.value);

    this.service.solicitud(data).subscribe(
      (resp: any) => {
        this.toastr.success('Solicitud de cambio de clave enviada, verifique su correo para completar solicitud', 'Éxito');
        this.dataForm.reset();
        this.router.navigate([''],{queryParams: {'hb':'1'}});
      }, err => {
        this.toastr.error((err.error.messages) ? err.error.messages[0] : err.error, 'Error');
      }
    );
  }

}
